/** Etapa comerciala si „la cine sta mingea" — tiparul TravelJoy, pe datele noastre.
 *  Numele si ordinea vin de la server (`/api/pipeline/etape`); aici stau doar culorile
 *  si micile ajutoare de afisare, ca sa arate la fel pe toate ecranele. */
export type Etapa = { cod: string; nume: string; numar?: number }

export const CULOARE_ETAPA: Record<string, string> = {
  cerere: 'bg-page text-muted',
  de_urmarit: 'bg-warn-soft text-warn',
  oferta_trimisa: 'bg-warn-soft text-warn',
  oferta_acceptata: 'bg-accent-soft text-accent-ink',
  confirmata: 'bg-accent-soft text-accent-ink',
  a_plecat: 'bg-good-soft text-good',
  s_a_intors: 'bg-page text-muted',
}

export const ASTEPTAM: { cod: string; nume: string }[] = [
  { cod: '', nume: '—' },
  { cod: 'noi', nume: 'Noi' },
  { cod: 'client', nume: 'Clientul' },
  { cod: 'furnizor', nume: 'Furnizorul' },
  { cod: 'nimeni', nume: 'Nimeni' },
]
